import {DocumentTypeList} from "./DocumentTypeList";
import {DocumentTypeEdit} from "./DocumentTypeEdit";
import {DocumentTypeCreate} from "./DocumentTypeCreate";

export default {
    list: DocumentTypeList,
    create: DocumentTypeCreate,
    edit: DocumentTypeEdit
};
